export const getAllCourses = (state) => state.course.courses;
export const getIsLoading = (state) => state.course.isLoading;
